import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface ProviderCodesResponse {
  providerCodes: { code: string; label: string }[];
}

export const useReferProviderCodes = () => {
  return useApi<ProviderCodesResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<ProviderCodesResponse>(
          "/amazon-clinic/care-plans/refer-out/provider-codes",
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.Referrals.PROVIDER_CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
